<template>
<div>
  <attritbute-overview :attribute="attribute"/>
</div>  
</template>
<script>
import AttritbuteOverview from './AttributeOverview'
import { mapGetters } from 'vuex'
import { find } from 'lodash'
export default {
  
  components: {
    AttritbuteOverview
  },

  computed: {
    ...mapGetters('assessor', [
      'assessor'
    ]),
    ...mapGetters('attributeType', [
      'attributeTypeList',
    ]),
    attribute() {
      return find(this.attributeTypeList, type => type.id === this.assessor.assessible_id)
    }
  }
}
</script>
